var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMapMark(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 15,
    height: 22,
    viewBox: "0 0 15 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".mark-a{fill:#252533;}.mark-b{clip-path:url(#mark-a);}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "mark-a"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "mark-a",
    width: 15,
    height: 22,
    transform: "translate(0 -0.107)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.266 -0.263)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "mark-b",
    transform: "translate(-0.266 0.37)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "mark-a",
    d: "M7.42,0A7.419,7.419,0,0,0,0,7.42C0,14.1,7.42,22.259,7.42,22.259S14.839,14.1,14.839,7.42A7.419,7.419,0,0,0,7.42,0m0,10.387a2.968,2.968,0,1,1,2.968-2.968A2.968,2.968,0,0,1,7.42,10.387",
    transform: "translate(0.184 -0.296)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapMark);
export default __webpack_public_path__ + "static/media/map-mark.1a3c6714.svg";
export { ForwardRef as ReactComponent };